import { render, staticRenderFns } from "./TradePage.vue?vue&type=template&id=7149394c&"
import script from "./TradePage.vue?vue&type=script&lang=js&"
export * from "./TradePage.vue?vue&type=script&lang=js&"
import style0 from "./TradePage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports